export default __webpack_public_path__ + "static/media/about_img2.3f860d28.png";